/** Central axios client — withCredentials so httpOnly cookies flow on every request.
 *  Auto-refreshes the access token on 401, then retries the original request once.
 */
import axios from "axios";

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${baseURL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const { config, response } = error;
    if (!response || !config) return Promise.reject(error);

    const isAuthEndpoint =
      config.url?.includes("/auth/login") ||
      config.url?.includes("/auth/register") ||
      config.url?.includes("/auth/refresh");

    if (response.status === 401 && !config._retried && !isAuthEndpoint) {
      config._retried = true;
      try {
        if (!refreshing) {
          refreshing = api.post("/auth/refresh");
        }
        await refreshing;
        refreshing = null;
        return api(config);
      } catch (e) {
        refreshing = null;
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

/** FastAPI 422 returns an array of {msg,...} — render-safe message extractor. */
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
